// extracted by mini-css-extract-plugin
export var backupIcon = "_ny-1";
export var image = "_ny-0";